export const BUNDLE_NAME = 'translations'

export const NO_CURRENT_STORE = 'NO_CURRENT_STORE'
